<template>
  <div>
    <Header />

    <h1>Rebar Models</h1>

    <h2>Template Models</h2>

    <table id="data-table">
      <colgroup>
        <col id="column-category">
        <col id="column-name">
        <col id="column-description">
      </colgroup>
      
      <tr>
        <th>Category</th>
        <th>Model Name</th>
        <th>Model Description</th>
      </tr>

      <tbody>
        <router-link tag="tr" v-for="(template, name) in templates" :key="`temp${name}`" :to="`/template/${name}`" >
          <td>
            {{ template['Category'] }}
          </td>
          <td class="series-name-text">
            {{ template['Label'] }}
          </td>
          <td class="series-description">
            {{ template['Description'] | truncate(60) }}
          </td>
        </router-link>
      </tbody>
    </table>


    <h2>Existing Models</h2>

    <table id="data-table">
      <colgroup>
        <col id="column-category">
        <col id="column-name">
        <col id="column-description">
      </colgroup>
      
      <tr>
        <th>Category</th>
        <th>Model Name</th>
        <th>Model Description</th>
      </tr>

      <tbody v-if="loaded">
        <router-link tag="tr" :to="`/model/${series['ID']}`" v-for="series in dataSeriesList" :key="series['ID']">
          <td>Stocks</td>
          <td>
            <span class="series-name-text">{{ series['Label'] }}</span>
              <br/>
            <span class="series-id-text">#{{ series['ID'] }}</span>
          </td>
          <td class="series-description">
            {{ series['Description'] | truncate(60) }}
          </td>
        </router-link>
      </tbody>
    </table>

    <br />
    <hr />

    <EmailCollection />

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import EmailCollection from '@/components/layout/EmailCollection';
import { templateMap } from '@/js/model/templates';

const axios = require('axios');
const _ = require('lodash');

export default {
  name: 'ModelListing',
  components: {
    Header,
    Footer,
    EmailCollection
  },
  data() {
    return {
      loaded: false,
      dataSeriesList: [],
      templates: templateMap
    }
  },
  filters: {
    truncate: function(text, maxLength) {
      if (text.length > maxLength) {
        return text.slice(0,maxLength) + '...';
      } else {
        return text;
      }
    },
    splitCategory: function(text) {
      return text.split('#').join(' / ');
    }
  },
  created() {
    this.loadRemoteData();
  },
  methods: {
    loadRemoteData() {
      axios.get(`${this.$api}/model`)
        .then((response) => {
          let responseData = (response.data || {});

          this.dataSeriesList = responseData;
          this.loaded = true;
        })
        .catch(() => console.log("Error loading data"));
    }
  }
}
</script>

<style scoped>
#data-table {
  margin-left: auto;
  margin-right: auto;
  width: 75%;
}

#data-table th {
  background-color: #0666b4;
  color: #ffffff;
  padding: 0 45px;
}
#data-table td {
  padding: 0 5px;
}
#data-table tr:hover, #data-table tr:hover {
  background-color:#edf3f7;
}

#column-description {
  width: 30%;
}

.series-id-text {
  color: gray;
  font-size: .8em;
}
.series-description {
  font-size: .8em;
}

.action-button {
  border: solid 1px;
  border-color: black;
  background-color: #43dbae;
  font-style: bold;
  border-radius: 4px;
}

@media only screen and (max-width: 800px) {
  th:nth-child(3), td:nth-child(3) {
    display:none;
  }
}
</style>
